import { render, staticRenderFns } from "./UpdateFactorySteps.vue?vue&type=template&id=72c2d901&scoped=true"
import script from "./UpdateFactorySteps.vue?vue&type=script&lang=ts"
export * from "./UpdateFactorySteps.vue?vue&type=script&lang=ts"
import style0 from "./UpdateFactorySteps.vue?vue&type=style&index=0&id=72c2d901&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c2d901",
  null
  
)

export default component.exports